import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ca-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss']
})
export class BrandingComponent {
  @Output()
  colorsSubmitted = new EventEmitter();
  @Output()
  imageSubmitted = new EventEmitter();
  @Output()
  imageRemoved = new EventEmitter();
  @Output()
  colorsReset = new EventEmitter();

  readonly INCLUDE_COLORS = false;
  readonly INCLUDE_PLACEHOLDER = false;

  @Input()
  set branding(value: any) {
    if (value) {
      let patch = { ...value };
      this._branding.get('media').reset();
      patch.media = value.media.reduce((prev, next) => ({ ...prev, [next.purpose]: next }), {});
      this._branding.patchValue(patch);
    }
  }

  get branding() {
    return this._branding;
  }

  get primary() {
    return this._branding.get('colors').get('primary').value;
  }

  set primary(value) {
    this._branding
      .get('colors')
      .get('primary')
      .setValue(value);
  }

  get secondary() {
    return this._branding.get('colors').get('secondary').value;
  }

  set secondary(value) {
    this.branding
      .get('colors')
      .get('secondary')
      .setValue(value);
  }

  _branding = new FormGroup({
    colors: new FormGroup({
      primary: new FormControl(''),
      secondary: new FormControl('')
    }),
    media: new FormGroup({
      memoBannerImage: new FormControl('', Validators.required),
      menuBackgroundImage: new FormControl('', Validators.required),
      logoIcon: new FormControl('', Validators.required)
    })
  });

  onSubmitColors() {
    this.colorsSubmitted.emit(this.branding.value.colors);
  }

  resetColors() {
    this.colorsReset.emit();
  }

  resetImage(controlName: string) {
    this.imageRemoved.emit(this._branding.get('media').get(controlName).value);
  }

  onImageSubmitted(purpose: string) {
    if (
      this.branding.get('media').get(purpose) &&
      this.branding.get('media').get(purpose).value &&
      this.branding.get('media').get(purpose).valid
    ) {
      if (this.branding.get('media').get(purpose).value.purpose) {
        // Image has already been saved/used
        return;
      }
      this.imageSubmitted.emit({ ...this.branding.get('media').get(purpose).value, purpose });
    }
  }
}
